import { defineMessages } from "react-intl";

export const scope = "components.DepositUnavailable";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Datos de tu cuenta personal",
  },
  alertSign: {
    id: `${scope}.alertSign`,
    defaultMessage:
      "Tu cuenta no está habilitada para recibir transferencias de este tipo.",
  },
});
